import BackgroundFileAddRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFileAddRequest";
import BackgroundFileGetDetailResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFileGetDetailResponse";
import { mapToCropRequest } from "@/frameworks/imagePreviewModelMapper";
import ImagePreviewModel from "crop-image/src/ImagePreviewModel";
import BackgroundTranslationViewModel from "./backgroundTranslationViewModel";

export default class CreateAnimationViewModel {
	id?: string = null;
	animationId?: string = null;
	animationUrl?: string = "";
	translations: BackgroundTranslationViewModel[] = [];
	backgroundImage: ImagePreviewModel = new ImagePreviewModel();
	categoryId?: number = null;
	fontColor?: string = '';

	get backgroundImageBase64(): string {
		const imageUrl = this.backgroundImage && this.backgroundImage.ImageUrl;
		return imageUrl && imageUrl.indexOf("data:") === 0 ? imageUrl : null;
	}

	get hasBackgroundImage(): boolean {
		const imageUrl = this.backgroundImage && this.backgroundImage.ImageUrl;
		return !!imageUrl && imageUrl !== "/assets/img/no_image.svg";
	}

	get hasNewBackgroundImage(): boolean {
		return !!this.backgroundImageBase64;
	}

	get normalizedCategoryId(): number {
		const categoryId = Number(this.categoryId);
		return Number.isFinite(categoryId) && categoryId > 0 ? categoryId : null;
	}

	initLanguages(languages: string[]) {
		this.translations = languages.map((langCode) => new BackgroundTranslationViewModel({
			langCode,
		}));
	}
	toServerModel(): BackgroundFileAddRequest {
		const backgroundImage = this.hasNewBackgroundImage
			? mapToCropRequest(this.backgroundImage)
			: null;
		const req = new BackgroundFileAddRequest({
			Id: this.id,
			AnimationId: this.animationId,
			Translations: this.translations.map((translation) => translation.toServerModel()),
			BackImage: backgroundImage,
			CoverImage: backgroundImage,
			Base64Content: this.backgroundImageBase64,
			FontColor: this.normalizedFontColor,
			CategoryId: this.normalizedCategoryId,
		});
		return req;
	}
	fromServerModel(model: BackgroundFileGetDetailResponse) {
        if (!model) {
			return;
        }
		this.id = model.Id;
		this.animationId = model.AnimationId;
		this.backgroundImage.ImageUrl = model.BackUrl;
		this.categoryId = this.normalizeCategoryId((model as any).CategoryId ?? (model as any).categoryId);
		this.fontColor = this.normalizeFontColor((model as any).FontColor ?? (model as any).fontColor);
		(model.Translations || []).forEach((serverTranslation) => {
			let translation = this.translations.find(
				(item) => item.langCode === serverTranslation.LangCode
			);
			if (!translation) {
				translation = new BackgroundTranslationViewModel({
					langCode: serverTranslation.LangCode,
				});
				this.translations.push(translation);
			}
			translation.id = serverTranslation.Id;
			translation.name = serverTranslation.Name;
		});
	}
	normalizeCategoryId(value: any): number {
		const categoryId = Number(value);
		return Number.isFinite(categoryId) && categoryId > 0 ? categoryId : null;
	}
	get normalizedFontColor(): string {
		return this.normalizeFontColor(this.fontColor);
	}
	normalizeFontColor(value: any): string {
		return String(value || "").replace(/#/g, "").replace(/[^0-9a-fA-F]/g, "").slice(0, 6).toUpperCase();
	}
}
